import { CheckIcon } from "lucide-react";
import React from "react";

interface SuccessViewProps {
  handleCloseModal: () => void;
  heading: string;
  message: string;
}

const SuccessView: React.FC<SuccessViewProps> = ({
  handleCloseModal,
  heading,
  message,
}) => {
  return (
    <div className="max-w-full md:max-w-[40vw] mx-auto flex flex-col items-center justify-center p-6 sm:p-12 text-center">
      <div className="w-20 h-20 border-2 border-primary text-primary rounded-full flex items-center justify-center mb-6">
        <CheckIcon className="w-8 h-8" />
      </div>

      <h2 className="text-2xl font-semibold text-gray-900 mb-6">{heading}</h2>

      <p className="text-gray-600 mb-8 max-w-md">{message}</p>

      <button
        onClick={handleCloseModal}
        className="px-3 py-2 hover:border hover:border-primary hover:text-primary bg-primary text-white rounded-md hover:bg-primary/80 transition-colors font-medium"
      >
        Ok, got it
      </button>
    </div>
  );
};

export default SuccessView;
